/** Sentinel of the client filter when it is not narrowing anything. */
export const ALL_CLIENTS = 'all';

export const ROTATION_OPTIONS = [
  { value: 'A', label: 'A · alta rotación' },
  { value: 'B', label: 'B · rotación media' },
  { value: 'C', label: 'C · baja rotación' },
];

export const KIT_MODE = {
  VIRTUAL: 'virtual',
  ASSEMBLED: 'assembled',
};

/** A component row of the kit editor before anything is picked. */
export const EMPTY_KIT_COMPONENT = { productId: null, quantity: 1 };

export const EMPTY_PRODUCT_FORM = {
  sku: '',
  name: '',
  barcode: '',
  price: '',
  base_uom: 'un',
  allows_fractional_qty: false,
  lot_controlled: false,
  expiry_controlled: false,
  serial_controlled: false,
  is_kit: false,
  kit_mode: KIT_MODE.VIRTUAL,
  components: [],
  rotation_class: 'B',
  weight: '',
  height: '',
  width: '',
  length: '',
  is_active: true,
};

/**
 * The columns of the bulk sheet, as the backend reads them. SKU and Nombre are
 * the only ones it insists on; the three flags take "sí" or "no".
 */
export const CATALOG_TEMPLATE_COLUMNS = [
  'SKU',
  'Nombre',
  'EAN',
  'Precio',
  'Peso',
  'Unidad',
  'Lote',
  'Vencimiento',
  'Serie',
  'Rotación',
];

export const CATALOG_TEMPLATE_EXAMPLE = {
  SKU: 'POL-001',
  Nombre: 'Polera básica talla M',
  EAN: '7801234567890',
  Precio: 9990,
  Peso: 180,
  Unidad: 'un',
  Lote: 'no',
  Vencimiento: 'no',
  Serie: 'no',
  Rotación: 'B',
};

/**
 * The most pages asked for when a whole catalog is needed as options. The
 * server caps a page at 100 products, so this is a catalog of a thousand.
 */
export const MAX_OPTION_PAGES = 10;
